import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateVendor } from "api/vendor.api";
import { invalidateVendorSide } from "lib/cacheInvalidation";

export const useUpdateVendor = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, ...body }) => updateVendor(id, body),
    onSuccess: () => invalidateVendorSide(queryClient),
  });
};
